import { render, staticRenderFns } from "./update-case-list-modal.vue?vue&type=template&id=06bec958&scoped=true"
import script from "./update-case-list-modal.vue?vue&type=script&lang=js"
export * from "./update-case-list-modal.vue?vue&type=script&lang=js"
import style0 from "./update-case-list-modal.vue?vue&type=style&index=0&id=06bec958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bec958",
  null
  
)

export default component.exports